var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('el-tooltip',{attrs:{"content":_vm.$t('report.manageReports'),"placement":"bottom"}},[_c('router-link',{attrs:{"to":"/reports"}},[_c('div',{staticClass:"manage-reports"},[_c('i',{staticClass:"vc-icon-server icon-xl mx-2 w-6 h-6 text-gray-400 hover:text-primary"})])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }